import { useCallback, memo } from 'react';
import { useNavigate } from 'react-router';
import { BonanzaLogo } from '@bonanza-social/moonlight';

function LinkedBonanzaLogo() {
  const navigate = useNavigate();

  const onBonanzaPress = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return <BonanzaLogo onBonanzaPress={onBonanzaPress} />;
}

export default memo(LinkedBonanzaLogo);
